import { render, staticRenderFns } from "./ThemeConfiguration.vue?vue&type=template&id=1faf6d09&"
import script from "./ThemeConfiguration.vue?vue&type=script&lang=js&"
export * from "./ThemeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
